/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Media_SlotsInputs */

const cs_draft_media_slots = /** @type {(inputs: Draft_Media_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrázky`)
};

const en_draft_media_slots = /** @type {(inputs: Draft_Media_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

/**
* | output |
* | --- |
* | "Images" |
*
* @param {Draft_Media_SlotsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_media_slots = /** @type {((inputs?: Draft_Media_SlotsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Media_SlotsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_media_slots(inputs)
	return cs_draft_media_slots(inputs)
});